export default "__VITE_ASSET__CWCaENaK__"